import Customer from '@/customer/models/Customer';
import CustomerProp from '@/customer/models/CustomerProp';
import customerList, { CustomerList } from '@/customer/models/CustomerList';
import customerQuery, { CustomerQuery } from '@/customer/models/CustomerQuery';
import customerFilter, { CustomerFilter } from '@/customer/models/CustomerFilter';
import customerImport, { CustomerImport } from '@/customer/models/CustomerImport';
import customerRemarkRule, { CustomerRemarkRule } from '@/customer/models/CustomerRemarkRule';
import Wxcard from '@/customer/models/Wxcard';
import CustomerRemark from '@/customer/models/CustomerRemark';
import CustomerGroup from '@/customer/models/CustomerGroup';

export interface CustomerState {
  searchFields: string[];
  displayFields: string[];
  props: CustomerProp[];
  showCustomerDetail: boolean;
  showCustomerExport: boolean;
  showCustomerAnalyze: boolean;
  currentCustomer?: Customer;
  customerGroups: CustomerGroup | any;
  memberCards: Wxcard[] | any;
  customerList: CustomerList;
  customerQuery: CustomerQuery | any;
  customerFilter: CustomerFilter | any;
  customerImport: CustomerImport | any;
  customerRemarkRule: CustomerRemarkRule | any;
  customerRemarkRules: CustomerRemarkRule[];
  mergingRemarks: CustomerRemark[];
  showTaskEntry: boolean;
  showChat: boolean;
  chatOpenid?: string;
  detailSelectedScore: boolean;
  duringFirstSync: boolean;
  syncPercent: number;
}

export const customerState: CustomerState = {
  searchFields: [],
  displayFields: [],
  props: [],
  showCustomerDetail: false,
  showCustomerExport: false,
  showCustomerAnalyze: false,
  currentCustomer: undefined,
  customerRemarkRule,
  customerRemarkRules: [],
  customerGroups: [],
  memberCards: [],
  mergingRemarks: [],
  customerList,
  showTaskEntry: false,
  showChat: false,
  detailSelectedScore: false,
  chatOpenid: undefined,
  customerQuery: JSON.parse(JSON.stringify(customerQuery)),
  customerFilter: JSON.parse(JSON.stringify(customerFilter)),
  customerImport: JSON.parse(JSON.stringify(customerImport)),
  duringFirstSync: false,
  syncPercent: 0,
};
